import { SvgIcon, type SvgIconProps } from './svgIcon'

export const DeleteIcon = ({
  width = 16,
  height = 18,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    {...props}>
    <path
      d="M5.39997 13.1538L7.99997 10.5538L10.6 13.1538L11.6538 12.1L9.0538 9.49999L11.6538 6.89999L10.6 5.84617L7.99997 8.44617L5.39997 5.84617L4.34615 6.89999L6.94615 9.49999L4.34615 12.1L5.39997 13.1538ZM1.5 17.5V2.99999H0.5V1.50002H4.99997V0.615417H11V1.50002H15.5V2.99999H14.5V17.5H1.5ZM2.99997 16H13V2.99999H2.99997V16Z"
      fill="currentColor"
    />
  </SvgIcon>
)
